import { Controller } from "@hotwired/stimulus"

// Tiny controller for the portfolio caption thumbnail strip. CSS handles
// the visual transition on hover; this controller handles click-to-pin so
// touch devices (which don't fire hover) can still expand a thumbnail.
//
// Markup contract:
//   <div data-controller="caption-thumbs">
//     <img ...>  <img ...>  <img ...>
//   </div>
//
// Click on a thumbnail toggles `.portfolio-caption__thumb--pinned` on it.
// Click outside the strip clears any pinned state.
export default class extends Controller {
  connect() {
    this._onClick      = this._onClick.bind(this)
    this._onDocClick   = this._onDocClick.bind(this)
    this.element.addEventListener("click", this._onClick)
    document.addEventListener("click", this._onDocClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this._onClick)
    document.removeEventListener("click", this._onDocClick)
  }

  _onClick(event) {
    const img = event.target.closest("img")
    if (!img || !this.element.contains(img)) return
    event.stopPropagation()
    // Toggle pin on this thumbnail; unpin siblings.
    const wasPinned = img.classList.contains("portfolio-caption__thumb--pinned")
    this._clearPins()
    if (!wasPinned) img.classList.add("portfolio-caption__thumb--pinned")
  }

  _onDocClick(event) {
    if (!this.element.contains(event.target)) this._clearPins()
  }

  _clearPins() {
    this.element.querySelectorAll(".portfolio-caption__thumb--pinned")
      .forEach(el => el.classList.remove("portfolio-caption__thumb--pinned"))
  }
}
